module.exports = __webpack_public_path__ + "img/ico_hot.72fe2091.png";